import { Component, ViewChild } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { ModalBase } from '@components/modal/modal';
import { NStepperComponent } from '@components/n-stepper/n-stepper.component';
import { NotificationContent } from '@components/notification/notification.interface';
import { NotificationService } from '@components/notification/notification.service';
import { ProgramyStudiowStudentaDoSlubowaniaDto } from '@interfaces/studia/platforma-studenta/slubowanie-program-studiow-studenta.interface';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SlubowanieProgramuStudiowStudentaService } from '@services/api/studia/platforma-studenta/slubowania-programu-studiow-stduenta.service';
import { tap } from 'rxjs';

@Component({
  selector: 'app-slubowanie-studenta-guard-modal',
  templateUrl: './slubowanie-studenta-guard-modal.component.html',
})
export class SlubowanieStudentaGuardModalComponent extends ModalBase {
  @ViewChild('stepper') stepper: NStepperComponent;
  data: ProgramyStudiowStudentaDoSlubowaniaDto[];
  stepControlDisabled = new FormControl(null, [Validators.required]);

  constructor(
    override readonly activeModal: NgbActiveModal,
    private readonly slubowanieProgramuStudiowStudentaService: SlubowanieProgramuStudiowStudentaService,
    private readonly notificationService: NotificationService,
  ) {
    super();
    this.title = $localize`Akceptacja ślubowania`;
  }

  akceptujSlubowanie(programStudiowStudentaSlubowanieId: string): void {
    this.stepControlDisabled.reset();
    this.slubowanieProgramuStudiowStudentaService
      .akceptujSlubowanie(programStudiowStudentaSlubowanieId)
      .pipe(
        tap(() => {
          const wiadomosc: NotificationContent = {
            label: $localize`Ślubowanie zaakceptowane`,
            message: $localize`Ślubowanie zostało zaakceptowane`,
          };
          this.notificationService.showSuccess(wiadomosc);
          if (this.stepper.selectedIndex !== this.data.length - 1) {
            this.stepControlDisabled.patchValue(true);
            this.stepper.next();
          } else {
            this.close();
          }
        }),
      )
      .subscribe();
  }
}
